import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { EnvironmentProviders, inject, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthInterceptor } from '../common/interceptors/auth.interceptor';
import { AuthenticationService } from './AuthenticationService';

@Injectable()
export class OAuth2AuthInterceptor extends AuthInterceptor {
  private readonly authService: AuthenticationService = inject(AuthenticationService);

  protected override getTokenAndIntercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      if (!this.authService.isLoggedIn()) {
        return next.handle(req);
      }

      this.authToken = this.authService.accessToken;

      return this.prepareInterception(req, next);
  }
}

export const OAuth2AuthInterceptorProvider: Provider | EnvironmentProviders = {
  provide: HTTP_INTERCEPTORS,
  useClass: OAuth2AuthInterceptor,
  multi: true,
};

